import React from 'react';
import { Button, Col, Container, Row } from "react-bootstrap";

const PaymentProcess = () => {
  return (
    <div className="paymentMain">
    <div className="payment-failure-main">
      <Container className="paymentContainer">
        <div className="payment-failureBox">
          <img className="payment-failureIcon" src="/assets/img/paymentFailedIcon.png" alt="!" />
          <div className="payment-failureContent">
            <h2 className="payment-failureTitle">Payment Failed</h2>
            <h6>Your payment was unsuccessful.</h6>
            <p className="payment-failureDesc">Our Takaful Specialist will contact you within 48 Hours or Call us now at <span className="text-primary">UAN: 111-832-682</span> </p>
            <Button>
              <a href="/gerrys" style={{ color: "white", textDecoration: "none" }}>Back to Home</a>
            </Button>
          </div>
        </div>
      </Container>
    </div>
    </div>
  );
};

export default PaymentProcess;
